import { axiosInstance } from '../client';
import { BASE_API_URL } from 'src/app/environment';
import { BusinessLocation } from '../types/business-types';

export type PublicLocation = Pick<
  BusinessLocation,
  'title' | 'name' | 'websiteUri' | 'metadata'
> & {
  settings?: { reviewLandingMessage?: string };
};

export async function fetchPublicLocation(
  locationId: string,
): Promise<PublicLocation | null> {
  try {
    const url = `${BASE_API_URL}/locations/${locationId}/public`;
    const res = await axiosInstance.get(url);
    if (res?.data?.success && res.data.data)
      return res.data.data as PublicLocation;
    return null;
  } catch (e) {
    return null;
  }
}
